export const currenciesConfig = {
  headings: [
    {
      headingLabel: "Inactive",
      icon: "",
      width: "10%",
      inputType: "checkbox",
    },
    {
      headingLabel: "Code",
      icon: "",
      inputType: "text",
      width: "20%",
    },
    {
      headingLabel: "Description",
      icon: "",
      inputType: "text",
      width: "45%",
    },
    {
      headingLabel: "Created On",
      icon: "",
      inputType: "text",
      width: "20%",
    },
  ],
  dataNodes: ["is_active", "currency_code", "description", "created_at"],
  primaryKey: "currency_id",
  actions: ["pen", "times"],
  nodeFields: [
    {
      column: "is_active",
      icon: "check",
    },
  ],
  buttonFields: [
    {
      column: "",
      icon: "pen",
    },
  ],
  inlineEdits: [
    {
      dataNode: "is_active",
      width: "9%",
    },
    {
      dataNode: "currency_code",
      width: "20%",
      isMandatory: true,
    },
    {
      dataNode: "description",
      width: "65%",
      isMandatory: true,
    },
  ],
};

export const currenciesConfigT2 = {
  headings: [
    {
      headingLabel: "Inactive",
      icon: "",
      width: "10%",
      inputType: "checkbox",
    },
    {
      headingLabel: "Code",
      icon: "",
      inputType: "text",
      width: "10%",
    },
    {
      headingLabel: "Currency Symbol",
      icon: "",
      inputType: "text",
      width: "15%",
    },
    {
      headingLabel: "Description",
      icon: "",
      inputType: "text",
      width: "35%",
    },
    {
      headingLabel: "Created On",
      icon: "",
      inputType: "text",
      width: "20%",
    },
  ],
  dataNodes: ["is_active", "currency_code","currency_symbol", "description", "created_at"],
  primaryKey: "currency_id",
  actions: ["pen", "times"],
  nodeFields: [
    {
      column: "is_active",
      icon: "check",
    },
  ],
  buttonFields: [
    {
      column: "",
      icon: "pen",
    },
  ],
  inlineEdits: [
    {
      dataNode: "is_active",
      width: "9%",
    },
    {
      dataNode: "currency_code",
      width: "10%",
      isMandatory: true,
    },
    {
      dataNode: "currency_symbol",
      width: "13%",
      isMandatory: true,
    },
    {
      dataNode: "description",
      width: "45%",
      isMandatory: true,
    },
  ],
};
export const currencyList = [
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 1,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 2,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 3,
  },
  {
    inactive: "yes",
    code: "1000",
    description: "[Description]",
    id: 4,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 5,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 6,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 7,
  },
  {
    inactive: " ",
    code: "1000",
    description: "[Description]",
    id: 8,
  },
];
